import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isBlank } from 'utils/helperMethods';
import { Box, Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BidRequestPresenter from 'presenters/BidRequestPresenter';
import BidReqeuestInfo from 'sharedComponents/BidRequestInfo';
import LoanOptions from 'sharedComponents/LoanOptions';

import useStyles from './useStyles';

const LoanOfficerControlPage = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bidRequest, chatUid, chatParticipant } = props;
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setActiveTabIndex(newValue);
  };

  const showBidRequestInfo = activeTabIndex === 0 && !isBlank(bidRequest);
  const showBidRequestInfoPlacheHolder = activeTabIndex === 0 && isBlank(bidRequest);
  const showLoanOptions = activeTabIndex === 1 && !isBlank(bidRequest);
  const showLoanOptionsPlaceHolder = activeTabIndex === 1 && isBlank(bidRequest);

  return (
    <Box className={classes.container}>
      <Tabs
        value={activeTabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab label={t('components.LoanOfficerControlPage.borrowersInfo')} value={0} className={classes.tab} />
        <Tab label={t('components.LoanOfficerControlPage.loanOptions')} value={1} className={classes.tab} />
      </Tabs>
      <Box className={classes.content}>
        {showBidRequestInfo && <BidReqeuestInfo bidRequest={bidRequest} chatParticipant={chatParticipant} />}
        {showBidRequestInfoPlacheHolder && <Box mt={2}>{t('components.LoanOfficerControlPage.noBidRequest')}</Box>}
        {showLoanOptions && <LoanOptions bidRequestId={bidRequest.id} chatUid={chatUid} />}
        {showLoanOptionsPlaceHolder && <Box mt={2}>{t('components.LoanOfficerControlPage.noBidRequest')}</Box>}
      </Box>
    </Box>
  );
};

LoanOfficerControlPage.propTypes = {
  bidRequest: BidRequestPresenter.shape(),
  chatUid: PropTypes.string.isRequired,
};

LoanOfficerControlPage.defaultProps = {
  bidRequest: {},
};

export default LoanOfficerControlPage;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerControlPage/LoanOfficerControlPage.js